module.exports = __webpack_public_path__ + "img/icon5.bf3288e4.svg";